export const isDebugEnvironment = process.env.NEXT_PUBLIC_USE_DEBUG === "true";
